import React, { lazy, Suspense } from "react";
import { FaCheck } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";
import HeadImageApp1 from "@/assets/citywise/waggex-payroll-software-noida-hero-all-in-one.webp";
import HeadImageAppMobile from "@/assets/citywise/waggex-payroll-software-noida-hero-all-in-one.webp?w=1150&format=webp";

const Whywaggexcommonchoice = lazy(
  () => import("./common/Whywaggexcommonchoice"),
);
const LookingforPayroll = lazy(() => import("./common/LookingforPayroll"));
const HomeFaq = lazy(() => import("../../pages/HomeFaq"));
const AppDownloadCard = lazy(() => import("../common/AppDownloadCard"));
const PayrollBanner = lazy(() => import("../common/PayrollBanner"));
const ModernizeHR = lazy(() => import("../common/ModernizeHR"));

const Noida = () => {
  const faq1 = [
    {
      title: "What Should You Look for in Payroll Software in Noida?",
      content:
        "Choose payroll software that automates salary processing, attendance, leave management, payslip generation, and statutory compliance. A centralized platform helps businesses reduce manual work, improve payroll accuracy, and simplify everyday HR operations.",
    },
    {
      title:
        "Can Payroll Software Handle Attendance, Leave, and Salary Calculations Together?",
      content:
        "Yes. Payroll software automatically uses attendance, approved leave, overtime, and shift data to calculate salaries accurately, eliminating manual calculations and reducing payroll errors.",
    },
    {
      title: "Is Payroll Software Suitable for Growing Businesses in Noida?",
      content:
        "Yes. Whether you're a startup, IT company, manufacturer, retailer, or service business, payroll software helps manage growing teams more efficiently by automating payroll and routine HR processes.",
    },
  ];

  const faq2 = [
    {
      title:
        "Can Employees Access Payslips and Apply for Leave Through the Mobile App?",
      content:
        "Yes. Employees can mark attendance, apply for leave, download payslips, check attendance history, and receive important company updates directly from the Staff App.",
    },
    {
      title: "How Does AI Attendance Improve Payroll Accuracy?",
      content:
        "AI-powered face recognition, GPS attendance, and geo-fencing help capture accurate attendance records, reducing buddy punching, manual errors, and payroll discrepancies before salary processing.",
    },
  ];

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",

      name: "Waggex",

      url: "https://www.waggex.com/best-payroll-software-in-noida",

      image: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Best payroll software in Noida for businesses and SMEs. Streamline payroll processing, attendance tracking, leave management, employee records, and workforce management.",

      applicationCategory: "BusinessApplication",

      operatingSystem: "Web, Android, iOS",

      featureList: [
        "Payroll software Noida",
        "Attendance management software Noida",
        "Leave and shift management Noida",
        "Face recognition attendance Noida",
        "Employee self-service app",
        "GPS attendance tracking",
        "Automated payroll processing",
        "AI selfie attendance",
      ],

      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "INR",
        description: "Free trial available",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        ratingCount: "250",
        bestRating: "5",
        worstRating: "1",
      },
      provider: {
        "@type": "Organization",
        name: "Waggex",
        url: "https://www.waggex.com",
        logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

        areaServed: {
          "@type": "Country",
          name: "India",
        },

        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+91-01724534553",
          email: "Info@waggex.com",
          contactType: "customer support",
        },
      },
    },

    {
      "@context": "https://schema.org",
      "@type": "FAQPage",

      mainEntity: [
        {
          "@type": "Question",
          name: "Which is the best payroll software in Noida?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The best payroll software depends on your business requirements. Waggex helps Noida businesses automate payroll, attendance management, leave tracking, and payslip generation from one connected platform.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support attendance-based payroll?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex links employee attendance, approved leave, and working hours directly to payroll, so salaries are calculated accurately without manual cross-checking.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex provide mobile attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Employees can mark attendance through the Waggex Staff App using selfie or GPS-based check-ins, suitable for office staff, factory workers, field teams, and remote employees.",
          },
        },
        {
          "@type": "Question",
          name: "Does Waggex support face recognition attendance?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Waggex offers AI-powered face recognition attendance via the FaceLens app for secure, contactless employee verification without any additional hardware.",
          },
        },
      ],
    },

    {
      "@context": "https://schema.org",
      "@type": "Organization",

      name: "Waggex",

      url: "https://www.waggex.com/",

      logo: "https://www.waggex.com/waggex-payroll-software-logo.png",

      description:
        "Waggex provides payroll and HRMS software for businesses in Noida and across India.",

      areaServed: "IN",

      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        availableLanguage: ["English", "Hindi"],
      },
    },

    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",

      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.waggex.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Payroll Software Noida",
          item: "https://www.waggex.com/best-payroll-software-in-noida",
        },
      ],
    },
  ];
  return (
    <>
      <Helmet>
        <title>Payroll Software in Noida - Salary, Attendance & HRMS</title>
        <meta
          name="description"
          content="Manage payroll, attendance, leave, and HR with Waggex payroll software in Noida. Automate salary processing and stay compliant"
        />
        <meta
          name="keywords"
          content="payroll software in Noida,payroll software Noida,HR software for businesses in Noida,attendance management software Noida,HRMS software Noida,online payroll system Noida,employee management software Noida,leave management software Noida,face recognition attendance Noida,payroll software for manufacturing companies Noida,payroll software for IT companies Noida"
        />
        <link
          rel="canonical"
          href="https://www.waggex.com/best-payroll-software-in-noida"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      </Helmet>
      <section className="relative overflow-hidden py-10 px-6 bg-[#D1DFEA]">
        <div className="relative z-10 max-w-6xl mx-auto text-center">
          <h1 className="text-xl sm:text-3xl font-roboto font-bold text-[#10324F] leading-tight max-w-2xl mx-auto">
            Payroll Software in Noida for Startups
            <br /> & Growing Businesses
          </h1>

          <p className="mt-5 text-sm sm:text-base lg:text-lg text-[#10324F] leading-relaxed max-w-4xl mx-auto">
            As your team grows, payroll becomes more complex. From salary
            processing and attendance to leave approvals and employee records,
            managing everything manually wastes valuable time. Streamline your
            entire payroll workflow from one centralized platform built for
            growing businesses
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() =>
                (window.location.href = "https://app.waggex.com/signup")
              }
              className="bg-[#17324D] text-white px-8 py-3 rounded-xl font-medium shadow-md hover:bg-[#10263B] transition-all w-full sm:w-auto"
            >
              Try Free for 5 Employees
            </button>

            <button
              onClick={() => (window.location.href = "/contact-us")}
              className="border border-[#17324D] text-[#17324D] px-8 py-3 rounded-xl font-medium hover:bg-[#17324D] hover:text-white transition-all w-full sm:w-auto"
            >
              Book Free Demo
            </button>
          </div>

          <div className="hidden lg:block">
            <div className="mt-16 flex justify-center aspect-1440/226">
              <img
                src={HeadImageAppMobile}
                width={1152}
                height={181}
                fetchPriority="high"
                alt="Waggex all-in-one payroll software Noida simplify payroll and workforce management for startups IT companies manufacturing and service businesses"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Noida's Fast-Growing Businesses
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base leading-relaxed">
              Whether you manage office teams, field employees, remote staff, or
              multiple branches, payroll should never slow your business down.
              Streamline payroll processing, attendance, leave management, and
              workforce operations through one platform designed for growing
              businesses
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated Payroll Processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift Management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-Based Salary Calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>PDF Payslip Generation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Self-Service App</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee Leave Management</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Face Recognition Attendance</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Process Payroll Faster with Greater Accuracy
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Every payroll cycle involves salary calculations, attendance
              verification, leave adjustments, overtime, and employee records.
              Automating these tasks helps Noida businesses reduce payroll
              errors, save valuable HR time, and process salaries with greater
              speed and accuracy
            </p>
          </div>
          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Automated payroll calculation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee salary reports</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based payroll processing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payroll history and records</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Overtime and shift salary management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Employee payroll notifications</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Payslip generation in PDF format</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-3xl mx-auto leading-loose">
            Once payroll is completed, employees receive instant notifications
            and can securely view or download their payslips anytime through the
            Staff App or employee portal, reducing routine payroll queries
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Attendance That Keeps Payroll Accurate
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Manage attendance for office employees, field staff, remote teams,
              and shift-based workforces with AI face recognition, GPS tracking,
              geo-fencing, and mobile attendance. Improve workforce visibility
              while reducing attendance errors and manual HR work
            </p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>AI Selfie Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift-Based Attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>GPS Attendance Tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mobile Attendance Marking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Geofencing</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-Time Attendance Reports</span>
              </div>
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>FaceLens AI Face Recognition Attendance</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Connect attendance with payroll and leave management through one
            platform, giving HR teams accurate records and faster payroll
            processing every month
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Simplify Leave & Shift Management
            </h2>

            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Managing leave requests, shift schedules, and employee
              availability manually can create delays and scheduling conflicts.
              Automate leave approvals, shift planning, and notifications to
              keep HR teams, managers, and employees aligned while reducing
              administrative work
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Yearly leave allocation</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave approval workflow</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Leave balance tracking</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Real-time leave notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Attendance-based leave management</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Shift management</span>
              </div>
            </div>{" "}
          </div>
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center max-w-2xl mx-auto leading-loose">
            Employees receive real-time updates when leave requests are
            submitted, approved, or rejected, while managers can review requests
            quickly and manage shifts from one centralized platform
          </p>
        </div>
      </section>
      <section className="bg-[#FFFFFF] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Everything Employees Need in One App
            </h2>
            <p className="mt-4 text-[#10324F] text-sm sm:text-base">
              Give employees the freedom to mark attendance, apply for leave,
              access payslips, and stay updated through one mobile app.
              Self-service access reduces HR dependency and makes everyday
              employee tasks faster and easier
            </p>
            <p className="mt-4 text-[#10324F] text-lg">Employee Can:</p>
          </div>
          {/* List */}
          <div className="mt-8 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Mark attendance</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>View attendance history</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Apply for leave </span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Receive notifications</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Download payslips</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Access employee records</span>
              </div>
            </div>
          </div>{" "}
          <p className="mt-8 text-[#10324F] text-sm sm:text-base text-center">
            Employees can manage routine HR tasks independently, helping HR
            teams reduce repetitive requests, save administrative time, and
            focus on higher-value business priorities
          </p>
        </div>
      </section>
      <section className="bg-[#F3F5F7] py-10 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Heading */}
          <div className="text-center">
            <h2 className="text-[#10324F] text-xl md:text-3xl font-bold uppercase">
              Built for Businesses of Every Size and Industry
            </h2>

            <p className="mt-4 text-[#10324F] text-lg">
              Designed to support businesses across every Indrustry:
            </p>
          </div>

          {/* List */}
          <div className="mt-10 flex justify-center">
            <div className="grid grid-cols-2 gap-x-5 md:gap-x-20 gap-y-5">
              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Startups</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Factories</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>SMEs</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Service Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>IT Companies</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Field Workforce Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Retail Businesses</span>
              </div>

              <div className="flex items-center gap-3 text-[#10324F]">
                <FaCheck className="mt-1 shrink-0 text-xl" />
                <span>Agencies & Consultancies</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Suspense fallback={null}>
        <Whywaggexcommonchoice
          heading="Built for Noida's Fast-Growing Business Environment"
          description="From startups and IT companies to manufacturing units and service businesses, organizations in Noida need payroll software that scales with their workforce. A centralized platform helps automate everyday HR processes, reduce manual effort, improve payroll accuracy, and simplify workforce management as businesses continue to grow"
          paragraph=""
        />
        <LookingforPayroll
          heading="Ready to Simplify Payroll & HR Operations?"
          subHeading="Book a Free Demo and See How It Works"
          description="See how one platform can automate payroll processing, attendance, leave management, employee records, and workforce operations helping Noida businesses save time, reduce manual work, and improve payroll accuracy"
          features={[
            "AI Attendance Management",
            "Payroll Automation",
            "Employee Self-Service App",
            "GPS & Face Recognition Attendance",
            "Attendance-Based Payroll",
            "Real-Time Notifications",
          ]}
          buttonText="Book Free Demo"
        />
        <HomeFaq
          faq1={faq1}
          faq2={faq2}
          subtitle="Everything you need to know about Waggex payroll software in India"
        />
        {/*  <AppDownloadCard /> */}
        <PayrollBanner
          heading="See How Easy Payroll Can Be"
          description="Experience payroll software designed to save time, reduce manual work, and improve accuracy—with no obligation to continue"
          buttonText="View HRMS Software"
          buttonLink="https://waggex.com/"
        />
        <AppDownloadCard />
        <ModernizeHR />
      </Suspense>
    </>
  );
};

export default Noida;
